import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { ButtonItem, Section } from '@atlaskit/menu';

// eslint-disable-next-line check-choreographer-usage/no-import-in-product-messages-without-choreographer

import { Box, xcss } from '@atlaskit/primitives';

import type { SpaceRole } from '../../model/space-roles-types';

const i18n = defineMessages({
	predefinedRoleListTitle: {
		id: 'space-roles.view-role-permissions-modal.predefined-role-list-title',
		defaultMessage: 'Confluence roles',
		description: 'Title for the predefined roles list',
	},
	customRoleListTitle: {
		id: 'space-roles.view-role-permissions-modal.custom-role-list-title',
		defaultMessage: 'Custom roles',
		description: 'Title for the custom roles list',
	},
});

const navContainerStyles = xcss({
	width: '202px',
});

export const RoleListButtons = ({
	systemRoles,
	customRoles,
	activeRoleId,
	setActiveRoleId,
}: {
	systemRoles: SpaceRole[];
	customRoles?: SpaceRole[];
	activeRoleId: string;
	setActiveRoleId: (roleId: string) => void;
}) => {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={navContainerStyles}>
			<Section title={formatMessage(i18n.predefinedRoleListTitle)}>
				{systemRoles.map((role) => (
					<ButtonItem
						key={role.id}
						isSelected={role.id === activeRoleId}
						onClick={() => setActiveRoleId(role.id)}
					>
						{role.name}
					</ButtonItem>
				))}
			</Section>
			{customRoles && customRoles.length > 0 && (
				<Section title={formatMessage(i18n.customRoleListTitle)}>
					{customRoles.map((role) => (
						<ButtonItem
							key={role.id}
							isSelected={role.id === activeRoleId}
							onClick={() => setActiveRoleId(role.id)}
						>
							{role.name}
						</ButtonItem>
					))}
				</Section>
			)}
		</Box>
	);
};
